<template>
    <div>
        <v-btn
            :disabled="loading"
            @click="openDialog"
            color="orange"
            x-small
            icon
            depressed
        >
            <v-icon>fi fi-rr-edit</v-icon>
        </v-btn>

        <v-dialog
            v-model="dialog"
            :fullscreen="isfullscreen"
            :max-width="isfullscreen ? '100%' : '800px'"
            scrollable
            persistent
        >
            <v-card>
                <v-card-title class="d-flex align-center">
                    <v-icon class="ml-2">fi fi-rr-edit</v-icon>
                    <span class="text-h6">تعديل الاستثمار</span>
                    <v-spacer />
                    <v-btn small @click="isfullscreen = !isfullscreen" icon>
                        <v-icon small>{{
                            isfullscreen
                                ? "fi fi-rr-compress"
                                : "fi fi-rr-expand"
                        }}</v-icon>
                    </v-btn>
                    <v-btn @click="closeDialog" icon small>
                        <v-icon small>fi fi-rr-cross</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider />

                <v-card-text class="pa-4">
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                            <!-- Operation Type -->
                            <v-col cols="12" md="6">
                                <v-select
                                    v-model="requestDto.operationType"
                                    :items="operationType"
                                    :rules="[$validations.required]"
                                    label="نوع العملية"
                                    item-text="text"
                                    item-value="value"
                                    outlined
                                    dense
                                    required
                                />
                            </v-col>

                            <!-- Amount -->
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model.number="requestDto.amount"
                                    :rules="[
                                        $validations.required,
                                        $validations.positiveNumber,
                                    ]"
                                    :disabled="isProfitOperation"
                                    :hint="
                                        isProfitOperation
                                            ? 'لا يمكن تغيير المبلغ لاستثمارات الأرباح'
                                            : ''
                                    "
                                    :persistent-hint="isProfitOperation"
                                    label="المبلغ"
                                    type="number"
                                    outlined
                                    dense
                                    required
                                />
                            </v-col>

                            <!-- User Selection -->
                            <v-col cols="12" md="6">
                                <v-autocomplete
                                    v-model="requestDto.userId"
                                    :items="users"
                                    :search-input.sync="filterUser.search"
                                    :loading="loadingUsers"
                                    :rules="[$validations.required]"
                                    item-text="fullName"
                                    item-value="id"
                                    label="المستخدم"
                                    clearable
                                    no-filter
                                    @click:clear="CleanFilterInvestor()"
                                    dense
                                    no-data-text="لا توجد بيانات"
                                    outlined
                                    required
                                >
                                    <template v-slot:prepend-item>
                                        <v-list-item>
                                            <v-divider />
                                            <v-pagination
                                                v-model="filterUser.pageIndex"
                                                :length="lengthUsers"
                                                :total-visible="7"
                                                @input="
                                                    getUsers(
                                                        filterUser.pageIndex,
                                                        filterUser.pageSize,
                                                        filterUser.search
                                                    )
                                                "
                                            />
                                        </v-list-item>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list-item-avatar
                                            color="indigo"
                                            class="text-h5 font-weight-light white--text"
                                        >
                                            {{ item.fullName.charAt(0) }}
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ item.fullName }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle dir="auto">
                                                {{ item.phoneNumber }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-col>

                            <!-- Receiver Name -->
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="requestDto.receiverName"
                                    label="اسم المستلم"
                                    outlined
                                    dense
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <h6 class="mb-1">
                                    تاريخ العملية
                                    <span class="required">*</span>
                                </h6>
                                <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dateText"
                                            placeholder="تاريخ العملية "
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            dense
                                            filled
                                            no-data-text="لا توجد بيانات"
                                            hide-details
                                            clearable
                                            @click:clear="clearDate()"
                                            outlined
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="requestDto.transactionDate"
                                        :active-picker.sync="activePicker"
                                        min="1950-01-01"
                                        :max="maxTransactionDate"
                                        @input="
                                            save(requestDto.transactionDate)
                                        "
                                        color="primary"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <!-- Transaction Date -->
                            <!-- <v-col cols="12" md="6">
                                <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="
                                        requestDto.transactionDate
                                    "
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dateText"
                                            label="تاريخ العملية"
                                            prepend-inner-icon="fi fi-rr-calendar"
                                            readonly
                                            outlined
                                            dense
                                            v-bind="attrs"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        v-model="requestDto.transactionDate"
                                        no-title
                                        scrollable
                                    >
                                        <v-spacer />
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="menu = false"
                                        >
                                            إلغاء
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="
                                                $refs.menu.save(
                                                    requestDto.transactionDate
                                                )
                                            "
                                        >
                                            موافق
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col> -->

                            <!-- Notes -->
                            <v-col cols="12">
                                <v-textarea
                                    v-model="requestDto.notes"
                                    label="الملاحظات"
                                    outlined
                                    dense
                                    rows="3"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-divider />

                <v-card-actions class="pa-4">
                    <v-spacer />
                    <v-btn @click="closeDialog" text color="grey">
                        إلغاء
                    </v-btn>
                    <v-btn
                        @click="updateInvestment"
                        :loading="loading"
                        :disabled="!valid || loading"
                        color="warning"
                        depressed
                        class="px-4"
                    >
                        <v-icon small left>fi fi-rr-disk</v-icon>
                        تحديث
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "EditInvestment",

    props: {
        investment: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            operationType: [
                {
                    text: "إيداع",
                    value: 1,
                },
                {
                    text: "سحب",
                    value: 2,
                },
                {
                    text: "أرباح",
                    value: 3,
                },
            ],
            requestDto: {
                // id: null,
                operationType: null,
                amount: 0,
                notes: null,
                receiverName: null,
                userId: null,
                transactionDate: null,
            },
            originalAmount: 0,
            dateText: null,
            isfullscreen: false,
            valid: true,
            dialog: false,
            loading: false,
            lengthUsers: 0,
            filterUser: {
                pageIndex: 1,
                pageSize: 15,
                search: null,
                count: 0,
            },
            loadingUsers: false,
            users: [],
            menu: false,
            activePicker: null,
        };
    },

    watch: {
        "filterUser.search": {
            handler: "handleSearchChange",
            deep: true,
        },
        "requestDto.transactionDate"(val) {
            this.dateText = this.formatDate(val);
        },
    },

    methods: {
        openDialog() {
            this.dialog = true;
            this.populateForm();
            this.getUsers(
                this.filterUser.pageIndex,
                this.filterUser.pageSize,
                this.filterUser.search
            );
        },

        closeDialog() {
            this.dialog = false;
            this.resetForm();
        },

        populateForm() {
            // Populate form with investment data
            this.requestDto = {
                id: this.investment.id,
                operationType: this.investment.operationType,
                amount: this.investment.amount,
                notes: this.investment.notes,
                receiverName: this.investment.receiverName,
                userId: this.investment.user?.id || this.investment.userId,
                transactionDate: this.investment.transactionDate
                    ? this.investment.transactionDate.split("T")[0]
                    : null,
            };
                    this.originalAmount = this.investment.amount;

            // Set user in autocomplete if exists
            if (this.investment.user) {
                this.users = [this.investment.user];
            }
        },

        resetForm() {
            this.requestDto = {
                id: null,
                operationType: null,
                amount: 0,
                notes: null,
                receiverName: null,
                userId: null,
                transactionDate: null,
            };
            this.originalAmount = 0;
            this.users = [];
            this.filterUser.search = null;
            this.$refs.form?.reset();
        },

        CleanFilterInvestor() {
            this.requestDto.userId = null;
            this.users = [];
            this.filterUser.search = null;
        },

        async handleSearchChange(newSearch, oldSearch) {
            setTimeout(async () => {
                await this.getUsers(
                    this.filterUser.pageIndex,
                    this.filterUser.pageSize,
                    newSearch
                );
            }, 1100);
        },

        async getUsers(pageIndex, pageSize, search) {
            this.loadingUsers = true;
            try {
                let queryUsers = `Users?IsDelete=false`;
                if (pageIndex !== undefined && pageIndex !== null) {
                    queryUsers = queryUsers + `&PageIndex=${pageIndex}`;
                }
                if (pageSize !== undefined && pageSize !== null) {
                    queryUsers = queryUsers + `&PageSize=${pageSize}`;
                }
                if (search !== undefined && search !== null) {
                    queryUsers += `&Search=${search}`;
                }
                const res = await this.$http.get(queryUsers);

                // If editing, keep the current user in the list
                const currentUsers = this.investment.user
                    ? [this.investment.user]
                    : [];
                const newUsers = res.data.result.data.filter(
                    (user) => !currentUsers.some((cu) => cu.id === user.id)
                );

                this.users = [...currentUsers, ...newUsers];
                this.filterUser.count = res.data.result.count;
                this.lengthUsers =
                    res.data.result.count === undefined
                        ? 0
                        : Math.ceil(
                              res.data.result.count / this.filterUser.pageSize
                          );
            } catch (err) {
                console.error("Error fetching users:", err);
                this.showError("حدث خطأ أثناء تحميل قائمة المستخدمين");
            } finally {
                this.loadingUsers = false;
            }
        },

        async updateInvestment() {
            if (!this.$refs.form.validate()) {
                return;
            }

            if (this.isFutureDate(this.requestDto.transactionDate)) {
                this.showError("تاريخ العملية لا يمكن أن يكون في المستقبل");
                return;
            }

            if (
                this.isProfitOperation &&
                Number(this.requestDto.amount) !== Number(this.originalAmount)
            ) {
                this.showError("لا يمكن تغيير المبلغ لاستثمارات الأرباح");
                this.requestDto.amount = this.originalAmount;
                return;
            }

            this.loading = true;
            try {
                const response = await this.$http.put(
                    `Investments/${this.requestDto.id}`,
                    this.requestDto
                );

                this.showSuccess(
                    response.data.message || "تم تحديث الاستثمار بنجاح"
                );
                this.closeDialog();
                this.$emit("refresh");
            } catch (error) {
                console.error("Error updating investment:", error);

                const errorMessages = this.extractApiErrorMessages(error);
                if (errorMessages.length > 0) {
                    errorMessages.forEach((message) => {
                        this.showError(message);
                    });
                } else {
                    this.handleApiError(error, "حدث خطأ أثناء تحديث الاستثمار");
                }
            } finally {
                this.loading = false;
            }
        },

        extractApiErrorMessages(error) {
            const data = error?.response?.data;
            const messages = [];

            if (Array.isArray(data?.result)) {
                messages.push(...data.result.filter(Boolean));
            }

            if (data?.errors && typeof data.errors === "object") {
                for (const key in data.errors) {
                    if (Object.prototype.hasOwnProperty.call(data.errors, key)) {
                        const errorValue = data.errors[key];
                        if (Array.isArray(errorValue)) {
                            messages.push(...errorValue.filter(Boolean));
                        } else if (errorValue) {
                            messages.push(errorValue);
                        }
                    }
                }
            }

            return messages;
        },

        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },

        isFutureDate(date) {
            if (!date) {
                return false;
            }

            return date > this.maxTransactionDate;
        },

        save(date) {
            if (this.$refs.menu && typeof this.$refs.menu.save === "function") {
                this.$refs.menu.save(date);
                return;
            }

            this.requestDto.transactionDate = date;
            this.menu = false;
        },
    },

    computed: {
        isProfitOperation() {
            return Number(this.requestDto.operationType) === 3;
        },

        maxTransactionDate() {
            const now = new Date();
            const tzOffset = now.getTimezoneOffset() * 60000;
            return new Date(now.getTime() - tzOffset)
                .toISOString()
                .split("T")[0];
        },
    },
};
</script>

<style scoped>
.v-card-title {
    background-color: rgba(0, 0, 0, 0.02);
}
</style>
